import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Form, FormInput, FormWrapper } from '../Helpers/Form';
import './Login.css';
import * as Actions from '../../actions/actions';

const Login = function (props) {
  const {
    loginVm,
    errorVm: { success, errorMessage },
    currentUserVm: { emailVerified },
    loginChange, login
  } = props;
  const { email, password } = loginVm;
  return (
    <div className="login" >
      <h1 >Login</h1>
      <Form

        onSubmit={() => login({ email, password }, emailVerified)}
        onChange={({ name, value }) => loginChange(name, value)}
        errorMessage={errorMessage}
        success={success}
      >
        <FormInput name="email" text="E-Mail" type="text" value={email} />
        <FormInput name="password" text="Passwort" type="password" value={password} />
        <FormWrapper><button className="button" >Login</button></FormWrapper>
      </Form>
      <div >
        <Link to="/register">
      Registrieren
        </Link>
      </div>
    </div>
  );
};

export default connect(
  state => ({ ...state.loginReducer, ...state.alertReducer, ...state.currentUserReducer }),
  dispatch => bindActionCreators(Actions, dispatch)
)(Login);



// WEBPACK FOOTER //
// ./src/pages/Login/index.js